import React, { useEffect, useState } from "react";
import {
  doc,
  getDoc,
  collection,
  addDoc,
  updateDoc,
  getDocs,
  serverTimestamp,
  increment,
  setDoc,
} from "firebase/firestore";
import { db, storage } from "../FirebaseConfig";
import useModalStore from "../StatesStore/ModalStore";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import { Modal, Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import { Upload, Progress } from "antd";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { v4 } from "uuid";
import axios from "axios";
import useThemeState from "../StatesStore/Theme";
import { Copy, TwitterX } from "react-bootstrap-icons";
import BottomTray from "../Trays/BottomTray";
import ShareShoppingList from "../Trays/ShareShoppingList";

const ListShareMenu = ({
  list,
  listName,
  myName,
  listLink,
  listId,
  userId,
  products,
  componentName,
  BackgroundOnSvg,
  closeOtherDropdown,
}) => {
  const { openModal } = useModalStore();
  const [content, setContent] = useState("");
  const [show, setShow] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [videoList, setVideoList] = useState([]);
  const [textContent, setTextContent] = useState("");
  const shareSVGBlack = process.env.PUBLIC_URL + "/assets/svgs/B-Share.svg";
  const shareSVGWhite = process.env.PUBLIC_URL + "/assets/svgs/Share.svg";
  const { theme } = useThemeState();
  const [showModal, setShowModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => setShowModal(false);
  // console.log("products from list sharemenu", products);

  const handleClose = () => setShow(false);
  // Function to handle copying the link to clipboard
  const handleCopyLink = async () => {
    try {
      if (products.length === 0) {
        toast.warn("You cannot copy an empty list link.", toastOptions);
        return;
      }
      await navigator.clipboard.writeText(listLink);
      toast.success("Link copied successfully", toastOptions);
    } catch (error) {
      console.error("Failed to copy link: ", error);
    }
  };
  const handleFacebookShare = (url, quote) => {
    // Open Facebook with the share URL and title
    const shareUrl = encodeURIComponent(url);
    const shareQuote = encodeURIComponent(quote);

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${shareQuote}`
    );
  };

  const handleWhatsappShare = (listLink, content) => {
    // Open WhatsApp with the share URL and title
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(`${listLink}`)}`
    );
  };
  const handleInstagramShare = (url, content) => {
    window.open(
      `https://www.instagram.com/direct/new/?text=${encodeURIComponent(url)}`
    );
  };

  const handleSnapchatShare = (url, content) => {
    const shareUrl = encodeURIComponent(url);
    const shareQuote = encodeURIComponent(content);

    window.open(`https://www.snapchat.com/scan?text=${shareUrl} ${shareQuote}`);
  };

  const handleTwitterShare = (title, url) => {
    const shareUrl = encodeURIComponent(url);
    const shareTitle = encodeURIComponent(title || `Check out ${listName}`);
    window.open(
      `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`
    );
  };

  const handleEmailShare = (title, shareUrl) => {
    // Open default email client with the share URL and title
    // window.location.href = `mailto:?subject=${encodeURIComponent(
    //   title
    // )}&body=${encodeURIComponent(shareUrl)}`;
    const DATA = {
      myName,
      shareURL: listLink,
      listName: list?.id,
    };
    openModal("ShoppingListInvite", "", DATA);
  };

  // Define the social media sharing options
  const socialMediaOptions = [
    {
      name: "Facebook",
      label: "Share via Facebook",
      icon: (
        <i className="bi bi-facebook fs-1" style={{ color: "#0057DA" }}></i>
      ),
      handler: (url, quote) =>
        handleSocialShare(() => handleFacebookShare(url, quote)),
    },
    {
      name: "Whatsapp",
      label: "Share via WhatsApp",
      icon: (
        <i className="bi bi-whatsapp fs-1" style={{ color: "#26d367" }}></i>
      ),
      handler: (url, content) =>
        handleSocialShare(() => handleWhatsappShare(url, content)),
    },
    // {
    //   name: "email",
    //   label: " Share via Email",
    //   icon: (
    //     <i
    //       className="bi bi-envelope fs-1"
    //       style={{ fontSize: "18px", color: "#EE3900" }}
    //     ></i>
    //   ),
    //   handler: (title, url) =>
    //     handleSocialShare(() => handleEmailShare(title, url)),
    // },
    {
      name: "Instagram",
      label: "Share via Instagram",
      icon: (
        <i className="bi bi-instagram fs-1" style={{ color: "#E1306C" }}></i>
      ),
      handler: (url, content) =>
        handleSocialShare(() => handleInstagramShare(url, content)),
    },
    // {
    //   name: "snapchat",
    //   label: " Share via Snapchat",
    //   icon: (
    //     <i
    //       className="bi bi-snapchat fs-1"
    //       style={{ fontSize: "18px", color: "#FFFC00" }}
    //     ></i>
    //   ),
    //   handler: (url, content) =>
    //     handleSocialShare(() => handleSnapchatShare(url, content)),
    // },
    {
      name: "X",
      label: "Share via X",
      icon: (
        <TwitterX className="fs-1" style={{ color: "black", height: "100%" }} />
      ),
      handler: (title, url) =>
        handleSocialShare(() => handleTwitterShare(title, url)),
    },
  ];
  const handleRemove = (file, setFileList) => {
    setFileList((prevFileList) =>
      prevFileList.filter((item) => item.uid !== file.uid)
    );
  };

  const uploadFiles = async () => {
    closeModal();
    let promises = [];
    let totalFiles = fileList.length + videoList.length;
    let completedFiles = 0;

    const updateProgress = () => {
      completedFiles += 1;
      setUploadProgress((completedFiles / totalFiles) * 100);
    };
    if (fileList.length === 0 && videoList.length === 0 && textContent) {
      // Handle text-only post

      setTextContent("");
      return;
    }
    if (fileList.length > 0) {
      const imagePromises = fileList.map((file) => {
        return new Promise((resolve, reject) => {
          const imageRef = ref(
            storage,
            `customPosts/images/${file.name + v4()}`
          );
          const uploadTask = uploadBytesResumable(imageRef, file);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log("Upload is " + progress + "% done");
            },
            (error) => {
              console.error("Error uploading image:", error);
              reject(error);
            },
            async () => {
              const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
              resolve({ type: "image", url: imageUrl });
              updateProgress();
            }
          );
        });
      });
      promises.push(...imagePromises);
    }

    if (videoList.length > 0) {
      const videoPromises = videoList.map((file) => {
        return new Promise((resolve, reject) => {
          const videoRef = ref(
            storage,
            `customPosts/videos/${file.name + v4()}`
          );
          const uploadTask = uploadBytesResumable(videoRef, file);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log("Upload is " + progress + "% done");
            },
            (error) => {
              console.error("Error uploading video:", error);
              reject(error);
            },
            async () => {
              const videoUrl = await getDownloadURL(uploadTask.snapshot.ref);
              resolve({ type: "video", url: videoUrl });
              updateProgress();
            }
          );
        });
      });
      promises.push(...videoPromises);
    }

    if (promises.length > 0) {
      try {
        const uploadedFiles = await Promise.all(promises);
        console.log("uploadedFiles", uploadedFiles);
        handleProfileShare(uploadedFiles);
        setUploadProgress(0);
      } catch (error) {
        console.error("Error uploading files:", error);
        setUploadProgress(0);
      }
    } else {
      handleProfileShare([]);
      console.log("No files to upload.");
    }
  };

  const handleProfileShare = async (mediaDocs) => {
    console.log("list", list);
    console.log("componentName", componentName);
    console.log("userId", userId);
    try {
      const shoppingListRef = doc(
        db,
        "users",
        list?.userId,
        "shoppingList",
        list?.id
      );
      const productsRef = collection(shoppingListRef, "products");
      const productsSnapshot = await getDocs(productsRef);

      // Get all product document IDs
      const products = productsSnapshot.docs.map((doc) => doc.id);
      console.log("Products in list:", products);

      // Check if products exist
      if (products.length === 0) {
        console.error("No products found in the list.");
        toast.warn(
          `You cannot share an empty list. Please add some products first.`,
          toastOptions
        );
        return;
      }
      // const thumbnailUrl = mediaDocs.length > 0 ? mediaDocs[0].url : null;
      // Use the uploaded thumbnail or fallback to the first product's image
      let thumbnailUrl = mediaDocs.length
        ? mediaDocs[0].url
        : products.length > 0
        ? await getProductImageUrl(products[0])
        : null;

      // Create a new post object
      const newPost = {
        dateCreated: serverTimestamp(),
        title: title || `${listName}`,
        description: description || ``,
        by: "user",
        userId: userId,
        thumbnailUrl: thumbnailUrl,
        type: "image",
        postType: "shoppingList",
        listId: listId,
        listName: listName,
        brands: list?.brands || [],
        category: list?.category || [],
        subCategory: list?.subCategory || [],
        subSubCategory: list?.subSubCategory || [],
        tags: list?.tags || [],
      };
      console.log("newPost", newPost);

      const postDocRef = await addDoc(collection(db, "posts"), newPost);

      const streamPost = {
        object: `${postDocRef.id}`,
        foreign_id: `${postDocRef.id}`,
        ...newPost,
        dateCreated: new Date().toISOString(),
        postId: `${postDocRef.id}`,
      };
      // Call the backend to add activity to Stream Feed
      await axios.post(`${process.env.REACT_APP_API}/api/createPost`, {
        userId: list?.userId,
        streamPost,
      });
      toast.success(`${listName} list shared successfully`, toastOptions);
      if (Array.isArray(list?.subSubCategory)) {
        for (const subUserId of list.subSubCategory) {
          await axios.post(`${process.env.REACT_APP_API}/api/createPost`, {
            userId: subUserId,
            streamPost,
          });
        }
      }

      // Save the media for each product
      for (const productId of products) {
        const productDocRef = doc(db, "products", productId);
        const productDoc = await getDoc(productDocRef);

        if (productDoc.exists()) {
          const productData = productDoc.data();
          const url = productData.imageUrl || [];

          const mediaDocRef = doc(postDocRef, "media", productDoc?.id);
          await setDoc(mediaDocRef, { url });
        }
      }

      await updateDoc(
        doc(db, "users", list?.userId, "shoppingList", list?.id),
        {
          visibility: "Public",
        }
      );

      await updateDoc(doc(db, "users", userId), {
        posts: increment(1),
      });
      setTitle("");
      setDescription("");
      setFileList([]);
    } catch (error) {
      toast.error("Failed to share list. Please try again.", toastOptions);
      console.error("Error adding post:", error);
    }
  };

  const getProductImageUrl = async (productId) => {
    const productDocRef = doc(db, "products", productId);
    const productDoc = await getDoc(productDocRef);

    if (productDoc.exists()) {
      const productData = productDoc.data();
      return productData.imageUrl || null;
    }
    return null;
  };

  const handleQuoteChange = (event) => {
    setContent(event.target.value);
  };
  const handleSocialShare = (handler) => {
    if (products.length === 0) {
      toast.warn(
        "You cannot share an empty list. Please add some products first.",
        toastOptions
      );
    } else {
      handler(listLink, content);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        className={`dropdown shareMenu nav-item ${
          componentName === "ProfilePage" ||
          componentName === "shopListMore" ||
          componentName === "ShoppingList" ||
          componentName === "favoritesMoreUserProfile"
            ? ""
            : "my-2"
        } ${listName?.split(" ")?.join("") + listId} Share`}
      >
        <div
          id="listShareMenu"
          onClick={() => {
            if (!isSmallScreen) setShowModal(true);
          }}
        >
          {componentName === "ProfilePage" ? (
            <img
              width={"28px"}
              src={theme === "dark" ? shareSVGWhite : shareSVGBlack}
              alt=""
              style={{ cursor: "pointer" }}
            />
          ) : componentName === "ShoppingList" ? (
            <div
              style={{
                width: "40px",
                height: "40px",
                cursor: "pointer",
              }}
              className="d-flex align-items-center justify-content-end"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.9975 12.0005C8.9975 13.3812 7.87821 14.5005 6.4975 14.5005C5.11679 14.5005 3.9975 13.3812 3.9975 12.0005C3.9975 10.6198 5.11679 9.50049 6.4975 9.50049C7.87821 9.50049 8.9975 10.6198 8.9975 12.0005Z"
                  stroke="#14191F"
                  stroke-width="1.5"
                />
                <path
                  d="M13.9985 6.49951L8.99854 9.99951"
                  stroke="#14191F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M13.9985 17.4995L8.99854 13.9995"
                  stroke="#14191F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M18.9995 18.5C18.9995 19.8807 17.8802 21 16.4995 21C15.1188 21 13.9995 19.8807 13.9995 18.5C13.9995 17.1193 15.1188 16 16.4995 16C17.8802 16 18.9995 17.1193 18.9995 18.5Z"
                  stroke="#14191F"
                  stroke-width="1.5"
                />
                <path
                  d="M18.9995 5.50049C18.9995 6.8812 17.8802 8.00049 16.4995 8.00049C15.1188 8.00049 13.9995 6.8812 13.9995 5.50049C13.9995 4.11978 15.1188 3.00049 16.4995 3.00049C17.8802 3.00049 18.9995 4.11978 18.9995 5.50049Z"
                  stroke="#14191F"
                  stroke-width="1.5"
                />
              </svg>
            </div>
          ) : componentName === "favoritesMoreUserProfile" ? (
            <div
              className="d-flex align-items-center"
              style={{ gap: "12px" }}
              onClick={() => {
                setShowModal(true);
                closeOtherDropdown();
              }}
            >
              <BackgroundOnSvg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.74817 9.00024C6.74817 10.0358 5.9087 10.8752 4.87317 10.8752C3.83764 10.8752 2.99817 10.0358 2.99817 9.00024C2.99817 7.96472 3.83764 7.12524 4.87317 7.12524C5.9087 7.12524 6.74817 7.96472 6.74817 9.00024Z"
                    stroke="#676A79"
                    stroke-width="1.00899"
                  />
                  <path
                    d="M10.4989 4.87476L6.7489 7.49976"
                    stroke="#676A79"
                    stroke-width="1.00899"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10.4989 13.1246L6.7489 10.4996"
                    stroke="#676A79"
                    stroke-width="1.00899"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14.2496 13.875C14.2496 14.9105 13.4102 15.75 12.3746 15.75C11.3391 15.75 10.4996 14.9105 10.4996 13.875C10.4996 12.8395 11.3391 12 12.3746 12C13.4102 12 14.2496 12.8395 14.2496 13.875Z"
                    stroke="#676A79"
                    stroke-width="1.00899"
                  />
                  <path
                    d="M14.2496 4.12549C14.2496 5.16102 13.4102 6.00049 12.3746 6.00049C11.3391 6.00049 10.4996 5.16102 10.4996 4.12549C10.4996 3.08996 11.3391 2.25049 12.3746 2.25049C13.4102 2.25049 14.2496 3.08996 14.2496 4.12549Z"
                    stroke="#676A79"
                    stroke-width="1.00899"
                  />
                </svg>
              </BackgroundOnSvg>
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                }}
              >
                Share
              </span>
            </div>
          ) : (
            <>
              <svg
                onClick={() => {
                  if (isSmallScreen) {
                    setIsOpen(true);
                  } else {
                    setShowModal(true);
                  }
                }}
                style={{
                  width: isSmallScreen ? "22px" : "26px",
                  height: isSmallScreen ? "22px" : "26px",
                }}
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.74723 13.0003C9.74723 14.4961 8.53467 15.7086 7.0389 15.7086C5.54313 15.7086 4.33057 14.4961 4.33057 13.0003C4.33057 11.5045 5.54313 10.292 7.0389 10.292C8.53467 10.292 9.74723 11.5045 9.74723 13.0003Z"
                  stroke="#14191F"
                />
                <path
                  d="M15.165 7.04129L9.74829 10.833"
                  stroke="#14191F"
                  stroke-linecap="round"
                />
                <path
                  d="M15.165 18.9578L9.74829 15.1662"
                  stroke="#14191F"
                  stroke-linecap="round"
                />
                <path
                  d="M20.5829 20.0416C20.5829 21.5373 19.3704 22.7499 17.8746 22.7499C16.3788 22.7499 15.1663 21.5373 15.1663 20.0416C15.1663 18.5458 16.3788 17.3333 17.8746 17.3333C19.3704 17.3333 20.5829 18.5458 20.5829 20.0416Z"
                  stroke="#14191F"
                />
                <path
                  d="M20.5829 5.95897C20.5829 7.45474 19.3704 8.66731 17.8746 8.66731C16.3788 8.66731 15.1663 7.45474 15.1663 5.95897C15.1663 4.46321 16.3788 3.25064 17.8746 3.25064C19.3704 3.25064 20.5829 4.46321 20.5829 5.95897Z"
                  stroke="#14191F"
                />
              </svg>
            </>
          )}
        </div>
      </div>
      <BottomTray
        text={"Share Shopping List"}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        <ShareShoppingList
          products={products}
          setShow={setShow}
          userId={userId}
          listLink={listLink}
        />
      </BottomTray>
      <Modal show={showModal} centered onHide={closeModal}>
        <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">Share Shopping List</div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={closeModal}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <p className="m-0">
              Send this shopping list to friends or family so they can view or
              collaborate with you. Choose how you'd like to share.
            </p>
          </div>
          <ul
            className={`p-0 m-0 ${listName?.split(" ")?.join("") +
              listId} Share`}
          >
            <li
              className={`w-100 d-flex justify-content-center gap-${
                isSmallScreen ? "3" : "5"
              }`}
            >
              {socialMediaOptions.map((option, index) => (
                <div
                  key={index}
                  className="d-flex flex-column align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => option.handler(listLink, content)}
                >
                  {option.icon}
                  {option.name}
                </div>
              ))}
            </li>
            {userId && (
              <Button
                variant="primary-soft"
                className="rounded-3 d-flex gap-2 py-1 align-items-center justify-content-center w-100 mt-3"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (products?.length === 0) {
                    toast.warn(
                      "Please add some products in the list before posting",
                      toastOptions
                    );
                  } else {
                    setShow(true);
                  }
                }}
              >
                <i className="bi bi-person-circle fs-5"></i>
                <span style={{ fontSize: "15px" }}>Post on Lookflock</span>
              </Button>
            )}
            <InputGroup className="mt-3">
              <Form.Control
                className="rounded-3 me-1 text-mute pe-5"
                value={listLink}
                readOnly
              />
              <div
                className="rounded me-3 mt-2 position-absolute end-0"
                style={{ zIndex: "10", cursor: "pointer" }}
                onClick={handleCopyLink}
              >
                <Copy className="fs-6" />
              </div>
            </InputGroup>
          </ul>
        </Modal.Body>
      </Modal>
      <Modal show={show} onHide={handleClose} centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title id="modalLabelCreateFeed">Create Post</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* <!-- Title --> */}
          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Add title here"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="Add description here"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
          </div>
          <div>
            <label className="form-label">Upload thumbnail</label>
            <Upload
              listType="picture"
              accept=".png,.jpg,.jpeg,.webp"
              className="dropzone dropzone-default card shadow-none"
              maxCount={1}
              multiple={true}
              fileList={fileList}
              // showUploadList={fileList.length===0?false:true}
              onRemove={(file) => handleRemove(file, setFileList)}
              beforeUpload={(file) => {
                setFileList((prevFileList) => [...prevFileList, file]);
                return false;
              }}
              style={{ backgroundColor: "#333", color: "white" }}
            >
              <div className="dz-message">
                <i className="bi bi-images display-3"></i>
                <p>Drag here or click to upload thumbnail.</p>
              </div>
            </Upload>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Row className="w-100 justify-content-between">
            <Col lg={3}>
              {/* Uncomment and use this section if you need to include a select option */}
              {/* <Form.Select className="js-choice choice-select-text-none">
              <option value="PB">Public</option>
              <option value="PV">Friends</option>
              <option value="PV">Only me</option>
              <option value="PV">Custom</option>
            </Form.Select> */}
            </Col>
            <Col lg={8} className="text-sm-end">
              <button
                onClick={() => {
                  uploadFiles();
                  handleClose();
                }}
                type="button"
                className="btn btn-primary-soft"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Post
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ListShareMenu;
